import { useTranslation } from "react-i18next"
import { Button } from "@cividao/components"
import { useLogos } from "../../../../hooks/useLogos"
import styles from "../index.module.css"

export function ChunkError() {
  const { t } = useTranslation("common", { keyPrefix: "newVersion" })
  const { logoFull: logoSrc } = useLogos()

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img className={styles.image} src={logoSrc} />
        <p className={styles.message}>{t("message")}</p>
        <Button onClick={handleReload} color="accent">
          {t("reload")}
        </Button>
      </div>
    </div>
  )
}
